import { useNavigate } from 'react-router';
import s from './Logo.module.scss';
import { ReactComponent as LogoIcon } from 'images/icons/logo.svg';

interface ILogoProps {
	className?: string;
}

export const Logo = ({ className }: ILogoProps) => {
	const navigate = useNavigate();

	return (
		<div className={`${s.logo} ${className}`} onClick={() => navigate('/')}>
			<div className={s.icon}>
				<LogoIcon />
			</div>
			<span>traffic.manager</span>
		</div>
	);
};
